<template>
	<div class="pageiframebox">
		<div class="common-header-wrap">
            <mt-header class="common-header" :title="title">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div class="iframebox">
        	<iframe :src="srcurl" frameborder="0"></iframe>
        </div>
	</div>
</template>

<script>
export default {
  data () {
    return {
      title:"Page",
      srcurl:""
    }
  },
  components: {
  },
  mounted () {
  	
  },
  created: function () {
	this.srcurl=this.$route.query.urls;
	this.title=this.$route.query.titles;
  },
  computed: {
    
  },
  methods: {
  	goBack () {
      this.$router.go(-1)
   	},
  }
}

</script>

<style lang="scss">
	.pageiframebox{}
	.iframebox{position: fixed;z-index: 10;width: 100%;height: 87%;left: 0px;top: 2rem;}
	.iframebox iframe{width: 100%;height: 100%;}
</style>